module.exports = __webpack_public_path__ + "img/howtouse01.00ada51d.jpg";